/**
 * Flow Component System Index
 *
 * This file imports all WhatsApp Flow components and auto-registers them with the
 * FlowComponentRegistry. Simply importing this file initializes the entire component system.
 */

import { flowComponentRegistry } from './FlowComponentRegistry';

// Import all flow components
// Display components
import { TextHeadingComponent } from './components/TextHeadingComponent';
import { TextSubheadingComponent } from './components/TextSubheadingComponent';
import { TextBodyComponent } from './components/TextBodyComponent';
import { TextCaptionComponent } from './components/TextCaptionComponent';
import { ImageComponent } from './components/ImageComponent';
import { EmbeddedLinkComponent } from './components/EmbeddedLinkComponent';
import { RichTextComponent } from './components/RichTextComponent';
import { ImageCarouselComponent } from './components/ImageCarouselComponent';

// Input components
import { TextInputComponent } from './components/TextInputComponent';
import { TextAreaComponent } from './components/TextAreaComponent';
import { DropdownComponent } from './components/DropdownComponent';
import { DatePickerComponent } from './components/DatePickerComponent';
import { CalendarPickerComponent } from './components/CalendarPickerComponent';
import { PhotoPickerComponent } from './components/PhotoPickerComponent';
import { DocumentPickerComponent } from './components/DocumentPickerComponent';
import { NavigationListComponent } from './components/NavigationListComponent';

// Selection components
import { RadioButtonsGroupComponent } from './components/RadioButtonsGroupComponent';
import { CheckboxGroupComponent } from './components/CheckboxGroupComponent';
import { OptInComponent } from './components/OptInComponent';
import { ChipsSelectorComponent } from './components/ChipsSelectorComponent';

// Action components
import { FooterComponent } from './components/FooterComponent';

// Layout components
import { IfComponent } from './components/IfComponent';
import { SwitchComponent } from './components/SwitchComponent';

// Define all components in order
const components = [
  // Display components
  TextHeadingComponent,
  TextSubheadingComponent,
  TextBodyComponent,
  TextCaptionComponent,
  ImageComponent,
  EmbeddedLinkComponent,
  RichTextComponent,
  ImageCarouselComponent,

  // Input components
  TextInputComponent,
  TextAreaComponent,
  DropdownComponent,
  DatePickerComponent,
  CalendarPickerComponent,
  PhotoPickerComponent,
  DocumentPickerComponent,
  NavigationListComponent,

  // Selection components
  RadioButtonsGroupComponent,
  CheckboxGroupComponent,
  OptInComponent,
  ChipsSelectorComponent,

  // Action components
  FooterComponent,

  // Layout components
  IfComponent,
  SwitchComponent,
];

// Auto-register all components
console.log('🔌 Initializing WhatsApp Flow Component System...');
flowComponentRegistry.registerAll(components);

// Log summary
const summary = flowComponentRegistry.getSummary();
console.log('📊 Flow Component System Summary:', summary);
console.log(`✅ Successfully registered ${summary.total} flow components`);

// Export the registry and base classes
export { flowComponentRegistry };
export { FlowComponent } from './FlowComponent';
export { FlowComponentRegistry } from './FlowComponentRegistry';

// Export all individual components for direct access if needed
export {
  // Display
  TextHeadingComponent,
  TextSubheadingComponent,
  TextBodyComponent,
  TextCaptionComponent,
  ImageComponent,
  EmbeddedLinkComponent,
  RichTextComponent,
  ImageCarouselComponent,
  // Input
  TextInputComponent,
  TextAreaComponent,
  DropdownComponent,
  DatePickerComponent,
  CalendarPickerComponent,
  PhotoPickerComponent,
  DocumentPickerComponent,
  NavigationListComponent,
  // Selection
  RadioButtonsGroupComponent,
  CheckboxGroupComponent,
  OptInComponent,
  ChipsSelectorComponent,
  // Action
  FooterComponent,
  // Layout
  IfComponent,
  SwitchComponent,
};
